import React, { FC, ReactNode } from 'react';
import { Box, Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import Link from 'next/link';

interface SafetyAndExcellenceProps extends StyleProps {
  title: string;
  description: ReactNode;
  hasTextBlock?: boolean;
}

type StyleProps = {
  image: string;
};

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      backgroundImage: ({ image }: Partial<StyleProps>) => `url(${image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      padding: theme.spacing(15, 0),
      marginTop: 0,
      minHeight: 673,
      backgroundPosition: 'center',
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(17, 0),
        marginTop: theme.spacing(13.5),
      },
    },
    title: {
      color: theme.palette.common.white,
      fontWeight: 800,
      maxWidth: 930,
      textAlign: 'center',
      fontSize: 40,
      lineHeight: '48px',
      [theme.breakpoints.up('md')]: {
        fontSize: 72,
        lineHeight: '86px',
      },
    },
    description: {
      color: theme.palette.common.white,
      maxWidth: 917,
      textAlign: 'center',
    },
    text: {
      color: theme.palette.common.white,
      maxWidth: 148,
    },
    buttonText: {
      color: theme.palette.primary.main,
      fontSize: 20,
      fontWeight: 600,
      textAlign: 'center',
      paddingTop: 18,
    },
    box: {
      cursor: 'pointer',
    },
  });
});

const SafetyAndExcellence: FC<SafetyAndExcellenceProps> = ({ title, description, image }) => {
  const classes = useStyles({ image });
  return (
    <Box className={classes.root} data-aos="fade-up" data-aos-delay="400">
      <Container fixed>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Typography className={classes.title}>{title}</Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} mt={5} mb={5}>
          <Typography variant="h5" className={classes.description}>
            {description}
          </Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
          <Box className={classes.box} minWidth={318} minHeight={60} bgcolor={'white'}>
            <Link href={'/safety'}>
              <Typography variant="h5" className={classes.buttonText}>
                {'Visit Our Safety Page'}
              </Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SafetyAndExcellence;
